"use client";

export default function ZakatHeader() {
  return (
    <header className="relative w-full overflow-hidden bg-[#0B1023]">
      {/* Decorative corner patterns */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-0 top-0 h-full w-1/3 bg-[url('/patterns/islamic-left.svg')] bg-no-repeat bg-left opacity-25" />
        <div className="absolute right-0 top-0 h-full w-1/3 bg-[url('/patterns/islamic-right.svg')] bg-no-repeat bg-right opacity-25" />
      </div>

      {/* Header Row */}
      <div className="relative flex h-[80px] items-center px-10">
        {/* Logo — extreme left */}
        <div className="text-[27px] font-extrabold tracking-tight text-[#E6C15A]">
          JustGold
        </div>

        {/* Spacer */}
        <div className="flex-1" />

        {/* Right Side */}
        <div className="flex items-center gap-9">
          <nav className="hidden md:flex items-center gap-8 text-[16px] font-medium text-white/90">
            <a href="#" className="hover:text-[#E6C15A]">
              Calculator
            </a>
            <a href="#" className="hover:text-[#E6C15A]">
              Learn
            </a>
            <a href="#" className="hover:text-[#E6C15A]">
              Donate
            </a>
            <a href="#" className="hover:text-[#E6C15A]">
              Download App
            </a>
          </nav>

          <button
            className="
              inline-flex
              items-center
              justify-center
              rounded-[14px]
              bg-[#F2CD4D]
              px-10
              py-3
              text-[18px]
              font-bold
              text-black
              shadow-[0_4px_12px_rgba(0,0,0,0.25)]
              transition-all
              duration-200
              hover:bg-[#F6D75E]
            "
          >
            Calculate Zakat
          </button>
        </div>
      </div>
    </header>
  );
}